import React from 'react';
import { Column, Columns } from '../../../Components/Elements/Layouts';
import Text from '../../../Components/Loaders/Text';

const TextLoadingHeight = 50;
const TextLoadingBorderRadius = 10;
export default function () {
  return (
    <div className="book-menu">
      <Columns mobile={true} gap={1}>
        <Column size={['5-mobile', '4-tablet', '5-desktop']}>
          <div className="book-menu__space">
            <Text radius={TextLoadingBorderRadius} height={TextLoadingHeight} />
          </div>
        </Column>
        <Column size={['7-mobile', '7-tablet']}>
          <Columns mobile={true} gap={1}>
            <Column size={['5-mobile', '6-tablet', '6-desktop']}>
              <Text
                radius={TextLoadingBorderRadius}
                height={TextLoadingHeight}
              />
            </Column>
            <Column size={3}>
              <Text
                radius={TextLoadingBorderRadius}
                height={TextLoadingHeight}
              />
            </Column>
          </Columns>
        </Column>
      </Columns>
    </div>
  );
}
